import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Message, MessageService } from 'primeng/api';
import { LoginService } from '../login/login.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  providers: [MessageService]
})
export class ForgotPasswordComponent implements OnInit {

  msgs: Message[] = [];
  model: any = {};
  showSpinner = false;
  showToggle = false;
  errorMessage: string;

  constructor(private router: Router,
    private messageService: MessageService,
    private loginService: LoginService) { }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login');
  }

  ngOnDestroy(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login');
  }

  forgotPassword(forgotPasswordData: any) {
    this.showSpinner = true;
    this.loginService.forgotPassword(forgotPasswordData).subscribe((result: any) => {
      this.showToggle = false;
      this.showSpinner = false;
      this.showSuccess(result.message);
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 2000);
    }, (error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 422 || error.status == 400) {
          this.errorMessage = "Email Address doesn't exists";
          this.showToggle = true;
        }
      }
      this.showSpinner = false;
    });
  }

  closeErrorDiv() {
    this.showToggle = !this.showToggle;
  }

  showSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: message, life: 2500 });
  }

}
